import { PrintoutConfigurationModel } from './types'

export const mockPrintoutConfiguration: PrintoutConfigurationModel = {
  printoutGenerationDate: true,
  printoutCompanyName: true,
  printoutDriverName: true,
  printoutDriverSignature: true,
  printoutIssuerSignature: false,
  printoutSingleGeneratedFileForEntity: false,
  driversCountForDocumentGeneration: 5,
  printTripVertically: true,
  evenPagesTimesheetPrint: false,
  extendPrintMargins: true,
  groupPageNumbersByDrivers: true,
  printEmploymentConditionsInfo: true,
  printWorkingTimeDeclaration: true,
  printEqualTreatmentDeclaration: false,
  printRiskDeclaration: true,
  printNoBanDeclaration: false,
  printForeignerDeclaration: false,
  otherEmploymentConditionsText: '',
};
